var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Events-Alt--Streamline-Carbon.svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 20 20",
    height: 25,
    width: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Events Alt Streamline Icon: https://streamlinehq.com")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "events--alt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 18.40625h1.1875v-1.1875a0.59410625 0.59410625 0 0 1 0.59375 -0.59375h3.5625a0.59410625 0.59410625 0 0 1 0.59375 0.59375v1.1875h1.1875v-1.1875a1.783209375 1.783209375 0 0 0 -1.78125 -1.78125h-3.5625a1.783209375 1.783209375 0 0 0 -1.78125 1.78125Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.84375a2.375 2.375 0 1 1 2.375 -2.375 2.377315625 2.377315625 0 0 1 -2.375 2.375Zm0 -3.5625a1.1875 1.1875 0 1 0 1.1875 1.1875 1.189103125 1.189103125 0 0 0 -1.1875 -1.1875Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 18.40625h1.1875v-1.1875a0.594284375 0.594284375 0 0 1 0.59375 -0.59375h3.5625a0.594284375 0.594284375 0 0 1 0.59375 0.59375v1.1875h1.1875v-1.1875a1.783209375 1.783209375 0 0 0 -1.78125 -1.78125H2.96875a1.783209375 1.783209375 0 0 0 -1.78125 1.78125Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 14.84375a2.375 2.375 0 1 1 2.375 -2.375 2.37749375 2.37749375 0 0 1 -2.375 2.375Zm0 -3.5625a1.1875 1.1875 0 1 0 1.1875 1.1875 1.188865625 1.188865625 0 0 0 -1.1875 -1.1875Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 9.5h1.1875v-1.1875a0.594284375 0.594284375 0 0 1 0.59375 -0.59375h3.5625a0.594284375 0.594284375 0 0 1 0.59375 0.59375v1.1875h1.1875v-1.1875a1.783209375 1.783209375 0 0 0 -1.78125 -1.78125h-3.5625a1.783209375 1.783209375 0 0 0 -1.78125 1.78125Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.9375a2.375 2.375 0 1 1 2.375 -2.375 2.37749375 2.37749375 0 0 1 -2.375 2.375Zm0 -3.5625a1.1875 1.1875 0 1 0 1.1875 1.1875 1.188865625 1.188865625 0 0 0 -1.1875 -1.1875Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 9.5h1.1875v-1.1875a0.5945218750000001 0.5945218750000001 0 0 1 0.59375 -0.59375h3.5625a0.5945218750000001 0.5945218750000001 0 0 1 0.59375 0.59375v1.1875h1.1875v-1.1875a1.783209375 1.783209375 0 0 0 -1.78125 -1.78125H2.96875a1.783209375 1.783209375 0 0 0 -1.78125 1.78125Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.9375a2.375 2.375 0 1 1 2.375 -2.375 2.377671875 2.377671875 0 0 1 -2.375 2.375Zm0 -3.5625a1.1875 1.1875 0 1 0 1.1875 1.1875 1.1886875 1.1886875 0 0 0 -1.1875 -1.1875Z",
    fill: "currentColor",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "_Transparent_Rectangle_",
    d: "M0 0h19v19H0Z",
    fill: "none",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/Teams.541a0c826367a6c8537ea98d276a83b5.svg";
export { ForwardRef as ReactComponent };